module.exports = __webpack_public_path__ + "img/oleg.r__600x600.2ff02444.jpg";